import React, { useContext } from "react";

import Dropdown from "Components/DesignSystem/Dropdown/Dropdown";

import { CSContext } from "../contexts/CSContext";
import { EMPTY_PIVOT_ELEMENT } from "../constants/CSConstants";
import { areObjectsIdentical } from "Pages/GMS/ISR/Components/RuleComponents/helper";

/**
 * Category picker on the DS `Dropdown` (searchable) — was the hand-rolled GMS
 * `Select` (light-only chrome, menu not portalled). `handleCategoryChange` still
 * receives the raw category-id string and the caller's `updateTotal`, and the
 * lock-after-first-mapping disabled expression is untouched.
 */
const CSCategorySelection = (props: { id: string, categoryId: string, updateTotal: (total: number) => void }) => {
    const { category, categoryList, handleCategoryChange, pivotVersionList, pivotList } = useContext(CSContext)
    const disabled = ["null", null, undefined, "undefined"].includes(props?.categoryId)
        ? false
        : true
    return (
        <div
            id={`${props.id}-category-container`}
            className="tw-m-5 tw-w-[25%]"
        >
            <Dropdown
                id={`${props.id}-category-select`}
                label="Category"
                options={categoryList ?? []}
                value={category as string}
                onChange={(value) => {
                    handleCategoryChange(String(value), props?.updateTotal);
                }}
                placeholder="Select Category"
                searchable
                usePortal
                disabled={Boolean(
                    disabled || (category && pivotVersionList?.length === 0 && pivotList && !areObjectsIdentical(pivotList[0], EMPTY_PIVOT_ELEMENT))
                )}
                data-testid={`${props.id}-category-select`}
            />
        </div>
    );
};

export default CSCategorySelection;
